import { Component, OnInit, ViewEncapsulation,  ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'page-not-found',
    templateUrl: './page-not.found.html',
})
export class PageNotFoundComponent implements OnInit {

    ngOnInit(): void {
       
    }
}